import { isNonEmptyString } from '@sniptt/guards';

import { getGraphqlErrorExtensions } from '@/apollo/utils/getGraphqlErrorExtensions';

// The message the server wrote for people, already in their language, or null
// when there is none (for example when the server couldn't be reached).
export const getUserFriendlyErrorMessage = (error: unknown) =>
  getGraphqlErrorExtensions(error)
    .map(({ userFriendlyMessage }) => userFriendlyMessage)
    .find(isNonEmptyString) ?? null;
